export default angular.module('predictiveSearch', [])
    /**
     * @ngdoc controller
     * @name search.controller:search
     * @description
     * Scope for a single search form
     */
    // @ngInject
    .controller('predictiveSearch', function ($scope, $http, AnalyticsService) {
        var controller = this;
        $scope.is_active = false;
        $scope.count = 0;
        $scope.search = '';
        $scope.section = '';
        $scope.results = [];
        $scope.action = '';
        $scope.method = 'GET';
        $scope.queryProperty = 'search';
        $scope.searchResults = function (search) {
            if (search && search.length > 2) {
                var count = ++$scope.count;
                var params = {
                  section: $scope.section
                };
                params[$scope.queryProperty] = search;
                $http({
                    url: $scope.action,
                    method: $scope.method,
                    params: params
                })
                    .success(function (data) {
                        if ($scope.count !== count) {
                            return;
                        }
                        else {
                            $scope.results = data.results || data;
                            AnalyticsService.trackEvent('Search', 'Submit', search);
                            AnalyticsService.trackPage(window.location.pathname + '/predictive-search?keyword=' + search);
                        }
                    })
                    .error(function (data) {
                        console.error(data);
                    });
            }
            else {
                $scope.results = [];
            }
        };
    })
    /**
     * @ngdoc directive
     * @name search.directive:search
     * @restrict A
     * @description
     * Creates a new scope and controller for each group instance
     */
    // @ngInject
    .directive('predictiveSearch', function ($timeout) {
        return {
            scope: true,
            controller: 'predictiveSearch',
            restrict: 'A',
            controllerAs: 'controller',
            link: function ($scope, $element, attrs, controller) {
                var active_class = attrs.elementClass || 'predictive-search--active';
                $scope.action = attrs.predictiveAction || attrs.action;
                $scope.method = attrs.predictiveMethod || attrs.method || 'GET';
                $scope.queryProperty = attrs.predictiveQuery || 'search';
                $scope.$watch(function () {
                    // remove in refactor to use controller.search
                    return controller.search || $scope.search;
                }, $scope.searchResults);
                $scope.$watch('is_active', function (is_active) {
                    $timeout(function () {
                      $element.toggleClass(active_class, is_active);
                    }, is_active ? 0 : 250);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name search.directive:searchField
     * @restrict A
     * @description
     * Set the state of the predictive search by focus/blur state
     */
    // @ngInject
    .directive('searchField', function ($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {

                $element.on('keydown', function (e) {
                    var key = e.keyCode || e.which;
                    if (key != 40 && key != 38 && key != 13) return;

                    // trigger click for when pressed 'Enter'
                    if (key == 13) {
                        var selectedAddress = angular.element(document.querySelector('.row-selected a'));
                        selectedAddress.triggerHandler('click');
                        return;
                    }

                    var current = null;
                    var rowSelected = angular.element(document.querySelector('.row-selected'));
                    if (rowSelected.length == 0) {
                        current = angular.element(document.querySelector('.row-default'));
                    } else {
                        rowSelected.removeClass('row-selected');
                        if (key == 40) {
                            current = rowSelected.next();
                        } else {
                            current = angular.element(rowSelected[0].previousElementSibling);
                        }
                    }
                    current.addClass('row-selected');
                });

                $element.on('focus blur', function (e) {
                    $timeout(function () {
                        $scope.is_active = e.type === "focus";
                    });
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name search.directive:predictiveSearchFillInput
     * @restrict A
     * @description
     * On click set the model value to the provided attribute string
     */
    // @ngInject
    .directive('predictiveSearchFillInput', function ($timeout) {
        return {
            require:'^predictiveSearch',
            link: function ($scope, $element, attrs, controller) {
                var fillValue = attrs.predictiveSearchFillInput;
                $element.on('click', function (e) {
                    $timeout(function () {
                        controller.search = fillValue;
                        angular.element(document.querySelector('.predictive-search--active')).removeClass("predictive-search--active");
                    });
                    e.preventDefault();                    
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name search.directive:predictiveSearch
     * @restrict A
     * @description
     * Allows users to run a predictive search and display results
     */
    // @ngInject
    .directive('predictiveSearchResults', function () {
        return {
            link: function ($scope, $element, attrs) {
                var active_class = attrs.elementClass || 'predictive-results--active';
                $scope.$watch(function () { return $scope.results; }, function (results) {
                    $element.toggleClass(active_class, results.length > 0);
                });
            }
        };
    });
